// VAST docs page — single-scroll layout, anchor nav, copy buttons

window.APP_ID = "svn5ks1d";

if (localStorage.getItem("theme") === "dark" ||
    (!("theme" in localStorage) &&
        window.matchMedia("(prefers-color-scheme:dark)").matches)) {
    document.documentElement.classList.add("dark");
} else { document.documentElement.classList.remove("dark"); }

// Smooth scroll to a hash target with sticky-nav offset.
// Does NOT mutate the URL hash — refresh stays at top, no jump-back behavior.
function scrollToHash(targetId) {
    const target = document.getElementById(targetId);
    if (!target) return;
    openDisclosureForTarget(target);
    const nav = document.getElementById('vast-sub-nav');
    const siteHeader = document.querySelector('body > nav.fixed, nav.fixed');
    const siteHeaderHeight = siteHeader ? siteHeader.offsetHeight : 0;
    const navVisible = nav && !nav.classList.contains('-translate-y-full');
    const navHeight = navVisible ? nav.offsetHeight : 0;
    const top = target.getBoundingClientRect().top + window.pageYOffset - siteHeaderHeight - navHeight - 12;
    window.scrollTo({ top, behavior: 'smooth' });
}

function openDisclosureForTarget(target) {
    const disclosure = target ? target.closest('details') : null;
    if (disclosure) disclosure.open = true;
    return disclosure;
}

function openDisclosureForHash() {
    const targetId = window.location.hash.slice(1);
    if (!targetId) return;
    const target = document.getElementById(targetId);
    openDisclosureForTarget(target);
}

function scrollToInitialHash() {
    const targetId = window.location.hash.slice(1);
    if (!targetId || !document.getElementById(targetId)) return;
    window.requestAnimationFrame(() => {
        window.setTimeout(() => scrollToHash(targetId), 30);
    });
}

function getSamePageHash(link) {
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return null;
    return url.hash ? url.hash.slice(1) : null;
}

// Force start-at-top on page load: disable browser scroll restoration and clear any incoming #hash.
if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
window.addEventListener('beforeunload', () => window.scrollTo(0, 0));

// Any internal link should open the collapsed section it points to before scrolling.
function initInternalAnchorLinks() {
    document.addEventListener('click', (e) => {
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        const link = e.target.closest('a[href^="#"]');
        if (!link) return;

        const targetId = link.getAttribute('href').slice(1);
        if (!targetId) return;
        const target = document.getElementById(targetId);
        if (!target) return;

        // Track steps need extra horizontal-scroll handling in initTracks.
        if (target.closest('.vast-track-shell')) return;

        e.preventDefault();
        scrollToHash(targetId);
    });

    window.addEventListener('hashchange', openDisclosureForHash);
}

// Dropdown menus are hover-only on fine-pointer devices (desktop/laptop).
function hasFinePointer() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
}

// Sub-anchor links inside dropdown menus: smooth-scroll + close menus
function initSubAnchorLinks() {
    if (!hasFinePointer()) return;
    document.querySelectorAll('.vast-nav-menu a[href]').forEach(link => {
        link.addEventListener('click', (e) => {
            const targetId = getSamePageHash(link);
            if (!targetId) return;
            if (!document.getElementById(targetId)) return;
            e.preventDefault();
            scrollToHash(targetId);
            document.querySelectorAll('.vast-nav-menu').forEach(m => m.classList.add('hidden'));
        });
    });
}

// Top-level nav triggers: hover dropdowns on fine-pointer devices only.
function initNavDropdowns() {
    const groups = document.querySelectorAll('.vast-nav-group');
    const dropdownsEnabled = hasFinePointer();
    let closeTimer = null;
    const closeAll = () => {
        document.querySelectorAll('.vast-nav-menu').forEach(m => m.classList.add('hidden'));
    };

    if (!dropdownsEnabled) closeAll();

    groups.forEach(group => {
        const menu = group.querySelector('.vast-nav-menu');
        const trigger = group.querySelector('a.vast-anchor');
        if (!menu || !trigger) return;

        if (dropdownsEnabled) {
            const open = () => {
                clearTimeout(closeTimer);
                document.querySelectorAll('.vast-nav-menu').forEach(m => { if (m !== menu) m.classList.add('hidden'); });
                menu.classList.remove('hidden');
            };
            const closeSoon = () => {
                clearTimeout(closeTimer);
                closeTimer = setTimeout(() => menu.classList.add('hidden'), 220);
            };

            group.addEventListener('mouseenter', open);
            group.addEventListener('mouseleave', closeSoon);
        }

        // Same-page triggers smooth-scroll; cross-page triggers navigate normally.
        trigger.addEventListener('click', (e) => {
            const targetId = getSamePageHash(trigger);
            if (!targetId) return;
            e.preventDefault();
            if (document.getElementById(targetId)) {
                scrollToHash(targetId);
            }
            menu.classList.add('hidden');
        });
    });

    if (dropdownsEnabled) {
        document.addEventListener('click', (e) => {
            if (!e.target.closest('.vast-nav-group')) closeAll();
        });
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') closeAll();
        });
    }
}

// Active section highlighting in the sticky nav
function initScrollSpy() {
    const links = Array.from(document.querySelectorAll('a.vast-anchor[href]'))
        .map(link => ({ link, id: getSamePageHash(link) }))
        .filter(item => item.id);
    if (!links.length) return;
    const sections = links.map(item => document.getElementById(item.id)).filter(Boolean);
    if (!sections.length) return;

    const setActive = (id) => {
        links.forEach(({ link, id: linkId }) => {
            const isActive = linkId === id;
            link.dataset.active = isActive ? 'true' : '';
            if (isActive) {
                link.classList.add('text-background-foreground', 'bg-muted');
                link.classList.remove('text-muted-foreground');
            } else {
                link.classList.remove('text-background-foreground', 'bg-muted');
                link.classList.add('text-muted-foreground');
            }
        });
    };

    const observer = new IntersectionObserver((entries) => {
        const visible = entries
            .filter(e => e.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio);
        if (visible.length) setActive(visible[0].target.id);
    }, { rootMargin: '-20% 0px -65% 0px', threshold: [0, 0.25, 0.5, 0.75, 1] });

    sections.forEach(s => observer.observe(s));
}

// Sub-nav visibility: hide while reading, reappear when the reader asks for it.
function initSubNavVisibility() {
    const subNav = document.getElementById('vast-sub-nav');
    if (!subNav) return;

    const siteHeader = document.querySelector('body > nav.fixed, nav.fixed');
    let lastScrollY = window.scrollY;
    let ticking = false;
    let hoveringNav = false;

    const headerHeight = () => siteHeader ? siteHeader.offsetHeight : 72;

    const show = () => {
        subNav.style.top = `${headerHeight()}px`;
        subNav.classList.remove('-translate-y-full');
        subNav.classList.add('translate-y-0');
    };

    const hide = () => {
        if (hoveringNav) return;
        subNav.classList.add('-translate-y-full');
        subNav.classList.remove('translate-y-0');
    };

    const update = () => {
        const currentScrollY = window.scrollY;
        const delta = currentScrollY - lastScrollY;
        const nearTop = currentScrollY < headerHeight() + subNav.offsetHeight + 40;

        subNav.style.top = `${headerHeight()}px`;
        if (nearTop || delta < -6) show();
        else if (delta > 6) hide();

        lastScrollY = currentScrollY;
        ticking = false;
    };

    const requestUpdate = () => {
        if (!ticking) {
            window.requestAnimationFrame(update);
            ticking = true;
        }
    };

    subNav.addEventListener('mouseenter', () => {
        hoveringNav = true;
        show();
    });
    subNav.addEventListener('mouseleave', () => {
        hoveringNav = false;
    });
    document.addEventListener('mousemove', (event) => {
        if (event.clientY <= headerHeight() + 28) show();
    }, { passive: true });
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);

    show();
}

// Carousel: show/hide arrows based on scroll position
function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(carousel => {
        const track = carousel.querySelector('[data-carousel-track]');
        const prev = carousel.querySelector('[data-carousel-prev]');
        const next = carousel.querySelector('[data-carousel-next]');
        if (!track || !prev || !next) return;

        function updateArrows() {
            const canScrollLeft = track.scrollLeft > 5;
            const canScrollRight = track.scrollLeft < track.scrollWidth - track.clientWidth - 5;
            prev.classList.toggle('hidden', !canScrollLeft);
            next.classList.toggle('hidden', !canScrollRight);
            if (canScrollLeft) prev.classList.add('flex'); else prev.classList.remove('flex');
            if (canScrollRight) next.classList.add('flex'); else next.classList.remove('flex');
        }

        prev.addEventListener('click', () => track.scrollBy({ left: -420, behavior: 'smooth' }));
        next.addEventListener('click', () => track.scrollBy({ left: 420, behavior: 'smooth' }));
        track.addEventListener('scroll', updateArrows);
        updateArrows();
        setTimeout(updateArrows, 500);
    });
}

// Copy-to-clipboard buttons (e.g., MCP endpoint)
function initCopyButtons() {
    document.querySelectorAll('.vast-copy').forEach(btn => {
        btn.addEventListener('click', () => {
            let text = btn.dataset.copy || '';
            if (!text && btn.dataset.copyTarget) {
                const target = document.querySelector(btn.dataset.copyTarget);
                text = target ? target.textContent.trim() : '';
            }
            const original = btn.innerHTML;
            const label = btn.dataset.copiedLabel || 'Copied';
            if (navigator.clipboard && text) {
                navigator.clipboard.writeText(text).then(() => {
                    btn.textContent = label;
                    setTimeout(() => { btn.innerHTML = original; }, 1600);
                });
            }
        });
    });
}

// Horizontal-scroll tutorial tracks (MCP setup steps, SDK walkthrough, etc.)
function initTracks() {
    const shells = document.querySelectorAll('.vast-track-shell');
    if (!shells.length) return;

    const authStepMap = [
        { nodes: ['agent'], flows: ['statement'] },
        { nodes: ['agent', 'auth'], flows: ['client'] },
        { nodes: ['auth', 'agent'], flows: ['token'] },
        { nodes: ['auth', 'data'], flows: ['introspection', 'rows'] },
        { nodes: ['agent', 'auth'], flows: ['refresh'] }
    ];

    function setAuthDiagramStep(i) {
        const diagram = document.querySelector('[data-auth-diagram]');
        if (!diagram) return;
        const state = authStepMap[i] || authStepMap[0];
        diagram.dataset.authActive = String(i + 1);
        diagram.querySelectorAll('[data-auth-active]').forEach(el => el.removeAttribute('data-auth-active'));
        state.nodes.forEach(name => {
            diagram.querySelectorAll(`[data-auth-node="${name}"]`).forEach(el => el.dataset.authActive = 'true');
        });
        state.flows.forEach(name => {
            diagram.querySelectorAll('[data-auth-flow]').forEach(el => {
                if ((el.getAttribute('data-auth-flow') || '').split(/\s+/).includes(name)) {
                    el.dataset.authActive = 'true';
                }
            });
        });
    }

    function clearAuthDiagramStep() {
        const diagram = document.querySelector('[data-auth-diagram]');
        if (!diagram) return;
        delete diagram.dataset.authActive;
        diagram.querySelectorAll('[data-auth-active]').forEach(el => el.removeAttribute('data-auth-active'));
    }

    shells.forEach(shell => {
        const list = shell.querySelector('[data-track-list]');
        const steps = Array.from(list.querySelectorAll('.vast-track-step'));
        const total = steps.length;
        if (!total) return;

        // Remove the old top nav (counter + arrow buttons) and dot pagination.
        const oldNav = shell.querySelector('.vast-track-nav');
        if (oldNav) oldNav.remove();
        const oldDots = shell.querySelector('[data-track-dots]');
        if (oldDots) oldDots.remove();

        // Minimal chrome: small counter + two arrow buttons. Nothing else.
        const pad2 = n => String(n).padStart(2, '0');
        const nav = document.createElement('div');
        nav.className = 'vast-track-nav';
        nav.innerHTML =
            '<p class="vast-track-counter"><strong data-track-current>01</strong> / ' + pad2(total) + '</p>' +
            '<div class="vast-track-arrows">' +
                '<button type="button" class="vast-track-arrow" data-track-prev aria-label="Previous step">' +
                    '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M15 18l-6-6 6-6" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                '</button>' +
                '<button type="button" class="vast-track-arrow" data-track-next aria-label="Next step">' +
                    '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                '</button>' +
            '</div>';
        list.parentNode.insertBefore(nav, list);

        const counter = nav.querySelector('[data-track-current]');
        const prevBtn = nav.querySelector('[data-track-prev]');
        const nextBtn = nav.querySelector('[data-track-next]');
        const stepperItems = [];
        const progressBar = null;
        const prevLabel = null;
        const nextLabel = null;
        let activeIndex = Number(list.dataset.mobileIndex || 0);

        function setActiveStep(i) {
            const active = Math.max(0, Math.min(total - 1, i));
            activeIndex = active;
            list.dataset.mobileIndex = String(active);
            list.dataset.hydrated = 'true';
            steps.forEach((step, idx) => {
                step.toggleAttribute('data-active', idx === active);
                step.setAttribute('aria-hidden', idx === active ? 'false' : 'true');
            });
            return active;
        }

        function scrollToIndex(i) {
            if (!steps[i]) return;
            setActiveStep(i);
            update();
        }
        function currentIndex() {
            return setActiveStep(activeIndex);
        }
        function update() {
            const i = currentIndex();
            if (counter) counter.textContent = pad2(i + 1);
            if (prevBtn) prevBtn.disabled = i <= 0;
            if (nextBtn) nextBtn.disabled = i >= total - 1;
            if (shell.dataset.track === 'auth-walk') {
                const disclosure = shell.closest('details');
                if (disclosure?.open) setAuthDiagramStep(i);
                else clearAuthDiagramStep();
            }
        }

        // Wire interactions.
        list.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
        window.addEventListener('resize', () => window.requestAnimationFrame(update));
        if (prevBtn) prevBtn.addEventListener('click', () => scrollToIndex(Math.max(0, currentIndex() - 1)));
        if (nextBtn) nextBtn.addEventListener('click', () => scrollToIndex(Math.min(total - 1, currentIndex() + 1)));

        document.addEventListener('click', (e) => {
            const a = e.target.closest('a[href^="#"]');
            if (!a) return;
            const id = a.getAttribute('href').slice(1);
            const idx = steps.findIndex(s => s.id === id);
            if (idx < 0) return;
            e.preventDefault();
            openDisclosureForTarget(shell);
            scrollToHash(shell.closest('details')?.id || shell.id);
            setTimeout(() => scrollToIndex(idx), 350);
        });

        window.addEventListener('load', () => {
            const id = window.location.hash.slice(1);
            if (!id) return;
            const idx = steps.findIndex(s => s.id === id);
            if (idx >= 0) {
                setTimeout(() => {
                    openDisclosureForTarget(shell);
                    scrollToHash(shell.closest('details')?.id || shell.id);
                    setTimeout(() => scrollToIndex(idx), 350);
                }, 100);
            }
        });

        update();

        if (shell.dataset.track === 'auth-walk') {
            const disclosure = shell.closest('details');
            if (disclosure) {
                disclosure.addEventListener('toggle', () => {
                    if (disclosure.open) setAuthDiagramStep(currentIndex());
                    else clearAuthDiagramStep();
                });
            }
        }
    });
}

// Tabs + filters (Resources section)
function initTabs() {
    function activateTab(group, id) {
        const tabs = group.querySelectorAll('.vast-tab');
        const panels = group.querySelectorAll('.vast-tab-panel');
        const target = group.querySelector('.vast-tab[data-tab="' + id + '"]');
        if (!target) return;
        tabs.forEach(t => t.toggleAttribute('data-active', t === target));
        panels.forEach(p => p.toggleAttribute('data-active', p.getAttribute('data-panel') === id));
    }

    function activateTabFromHash() {
        const hash = window.location.hash.replace('#', '');
        if (!hash) return;
        const panel = document.getElementById(hash);
        if (!panel || !panel.classList.contains('vast-tab-panel')) return;
        const group = panel.closest('[data-tabs]');
        if (!group) return;
        activateTab(group, panel.getAttribute('data-panel'));
    }

    // Cross-document: nav links with data-tab-link can activate any tab group's panel.
    document.addEventListener('click', (e) => {
        const link = e.target.closest('[data-tab-link]');
        if (!link) return;
        const url = new URL(link.href, window.location.href);
        if (url.pathname !== window.location.pathname) return;
        const id = link.getAttribute('data-tab-link');
        // For now we only have one tabs group (resources). If we add more, scope by data-tabs="X".
        const group = document.querySelector('[data-tabs]');
        if (group) activateTab(group, id);
    });

    document.querySelectorAll('[data-tabs]').forEach(group => {
        const tabs = group.querySelectorAll('.vast-tab');
        const panels = group.querySelectorAll('.vast-tab-panel');
        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const id = tab.getAttribute('data-tab');
                tabs.forEach(t => t.toggleAttribute('data-active', t === tab));
                panels.forEach(p => p.toggleAttribute('data-active', p.getAttribute('data-panel') === id));
            });
        });
    });

    activateTabFromHash();
    window.addEventListener('hashchange', activateTabFromHash);
}

function initArticleFilters() {
    const filterBox = document.querySelector('[data-article-filters]');
    const grid = document.querySelector('[data-article-grid]');
    if (!filterBox || !grid) return;
    const buttons = filterBox.querySelectorAll('[data-filter]');
    const cards = grid.querySelectorAll('[data-source]');
    buttons.forEach(b => {
        b.addEventListener('click', () => {
            const filter = b.getAttribute('data-filter');
            buttons.forEach(x => x.toggleAttribute('data-active', x === b));
            cards.forEach(c => {
                const src = c.getAttribute('data-source');
                c.style.display = (filter === 'all' || src === filter) ? '' : 'none';
            });
        });
    });
}

// Reveal section headers as they enter the viewport. CSS stays visible by default
// unless this initializer opts the page into reveal motion.
function initRevealMotion() {
    const items = Array.from(document.querySelectorAll('[data-reveal]'));
    if (!items.length) return;

    document.documentElement.classList.add('vast-reveal-ready');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        items.forEach(item => item.classList.add('is-revealed'));
        return;
    }

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-revealed');
            obs.unobserve(entry.target);
        });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });

    items.forEach(item => observer.observe(item));
}

// Scroll-driven motion: parallax on ghost section numbers, hero fade-on-scroll
function initParallaxLayer() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const ghosts = Array.from(document.querySelectorAll('[data-ghost-num]'));
    const heroDiagram = document.querySelector('.vast-flow');
    const heroSection = document.getElementById('vast-hero');
    let ticking = false;

    function update() {
        ghosts.forEach(g => {
            const parent = g.closest('[data-section-num]') || g.parentElement;
            if (!parent) return;
            const rect = parent.getBoundingClientRect();
            if (rect.bottom < 0 || rect.top > window.innerHeight) return;
            const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
            const offset = (progress - 0.5) * 60;
            g.style.transform = 'translateY(' + offset + 'px)';
        });
        if (heroDiagram && heroSection) {
            const heroRect = heroSection.getBoundingClientRect();
            const heroProgress = Math.min(1, Math.max(0, -heroRect.top / heroSection.offsetHeight));
            heroDiagram.style.opacity = String(1 - heroProgress * 0.6);
            heroDiagram.style.transform = 'translateY(' + (heroProgress * -40) + 'px)';
        }
        ticking = false;
    }

    window.addEventListener('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(update);
            ticking = true;
        }
    }, { passive: true });
    update();
}

document.addEventListener('DOMContentLoaded', () => {
    openDisclosureForHash();
    initInternalAnchorLinks();
    initRevealMotion();
    initSubAnchorLinks();
    initNavDropdowns();
    initScrollSpy();
    initSubNavVisibility();
    initCarousels();
    initCopyButtons();
    initTracks();
    initTabs();
    initArticleFilters();
    initParallaxLayer();
    scrollToInitialHash();
});
